import { takeLatest, call, put } from 'redux-saga/effects';
import empSearchApi from 'api/employee/empSearchApi';
import * as changePhotoActions from 'redux/ducks/changePhoto/changePhotoDucks';
import * as alertActions from 'redux/ducks/common/alertDucks';

export function* getThumbImg({ payload }) {
  try {
    const response = yield call(empSearchApi.getThumbImg, payload);
    yield put(changePhotoActions.getThumbImgSuccess(response));
  } catch (error) {
    yield put(alertActions.open({ message: [error.errorCode] }));
  }
}

export function* addPhotoRegister({ payload }) {
  try {
    const response = yield call(empSearchApi.addPhotoRegister, payload);
    if (response) {
      const responseCall = yield call(empSearchApi.getThumbImg, payload.epid);
      yield put(changePhotoActions.addPhotoRegisterSuccess(responseCall));
    }
  } catch (error) {
    yield put(alertActions.open({ message: [error.errorCode] }));
  }
}

export function* getImageEditorDomain() {
  try {
    const response = yield call(empSearchApi.getImageEditorDomain);
    yield put(changePhotoActions.getImageEditorDomainSuccess(response));
  } catch (error) {
    yield put(alertActions.open({ message: [error.errorCode] }));
  }
}

export default function* changePhotoSaga() {
  yield takeLatest(changePhotoActions.getThumbImg, getThumbImg);
  yield takeLatest(changePhotoActions.addPhotoRegister, addPhotoRegister);
  yield takeLatest(changePhotoActions.getImageEditorDomain, getImageEditorDomain);
}
